import * as React from 'react';
import { Alert, Divider } from '@mui/material';

import { InputForm } from './InputForm';
import { UploadForm } from './UploadForm';
import { TrackContainers } from '../../../types';

interface Props {
  setFiles: (files: File[]) => void;
  setNumbers: (numbers: string[]) => void;
  prepopulatedContainers: string[];
  method: TrackContainers['method'] | null;
}

export const Containers: React.FC<Props> = (props) => {
  const { setFiles, setNumbers, prepopulatedContainers, method } = props;

  return (
    <div className="pt-2">
      <div className="px-8 space-y-8 grow flex flex-col">
        <div className="flex grow">
          <InputForm
            onContainersListed={setNumbers}
            disabled={method === 'upload'}
            prepopulatedContainers={prepopulatedContainers}
          />
          <Divider
            orientation="vertical"
            flexItem
            className="px-2 mt-8"
            classes={{
              root: 'before:border-gray-500 before:border-l-2 after:border-gray-500 after:border-l-2',
            }}
            sx={{
              height: '192px',
            }}
          >
            <h3>Or</h3>
          </Divider>
          <UploadForm onFileSelected={setFiles} disabled={method === 'input'} />
        </div>
        {prepopulatedContainers && prepopulatedContainers.length > 0 && (
          <Alert icon={false} severity="warning">
            {prepopulatedContainers.length} of the containers you searched are not yet tracked,
            would you like to add {prepopulatedContainers.length > 1 ? 'them' : 'it'}?
          </Alert>
        )}
      </div>
    </div>
  );
};
